import { Instagram, Phone, Mail, MapPin, Rss } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import Logo from "./Logo";
import { useBooking } from "./BookingDialog";

export default function Footer() {
  const { openBooking } = useBooking();
  const location = useLocation();
  const onHome = location.pathname === "/";
  const a = (hash) => (onHome ? hash : `/${hash}`);
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#0A1838] text-[#F8F1D8] pt-20 pb-10 overflow-hidden grain"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
        <div className="grid grid-cols-12 gap-10 pb-16 border-b border-[#F8F1D8]/15">
          <div className="col-span-12 md:col-span-5">
            <Logo tone="gold" size="lg" showFrame showSubtitle />
            <p className="mt-8 max-w-md text-sm leading-relaxed font-light opacity-80">
              A welcoming wellness space designed to help you slow down, soften,
              and leave feeling more like yourself.
            </p>
          </div>

          <div className="col-span-6 md:col-span-3">
            <div className="overline mb-5" style={{ color: "#EAD584" }}>Visit</div>
            <ul className="space-y-3 text-sm font-light">
              <li>
                <a href={a("#services")} className="link-underline" data-testid="footer-link-services">Services</a>
              </li>
              <li>
                <a href={a("#about")} className="link-underline" data-testid="footer-link-about">About</a>
              </li>
              <li>
                <a href={a("#gallery")} className="link-underline" data-testid="footer-link-gallery">Gallery</a>
              </li>
              <li>
                <a href={a("#gift-cards")} className="link-underline" data-testid="footer-link-gift-cards">Gift Cards</a>
              </li>
              <li>
                <Link to="/blog" className="link-underline" data-testid="footer-link-blog">Blog</Link>
              </li>
              <li>
                <a href={a("#contact")} className="link-underline" data-testid="footer-link-contact">Contact</a>
              </li>
            </ul>
          </div>

          <div className="col-span-6 md:col-span-4">
            <div className="overline mb-5" style={{ color: "#EAD584" }}>Contact</div>
            <address className="not-italic">
            <ul className="space-y-4 text-sm font-light">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-1 opacity-70" />
                <a href="tel:9162435514" data-testid="footer-phone" className="link-underline">916-243-5514</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-1 opacity-70" />
                <a href="mailto:Bella@triplebtherapy.com" data-testid="footer-email" className="link-underline break-all">Bella@triplebtherapy.com</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-1 opacity-70" />
                <span>Downtown Sacramento, CA</span>
              </li>
            </ul>
            </address>
            <div className="mt-8 flex items-center gap-3">
              <a
                href="https://www.instagram.com/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                data-testid="footer-instagram"
                className="w-11 h-11 rounded-full border border-[#F8F1D8]/30 inline-flex items-center justify-center hover:bg-[#F8F1D8]/10 transition-colors"
              >
                <Instagram className="w-4 h-4" />
              </a>
              <a
                href={`${process.env.REACT_APP_BACKEND_URL}/api/rss.xml`}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="RSS feed"
                title="Subscribe via RSS"
                data-testid="footer-rss"
                className="w-11 h-11 rounded-full border border-[#F8F1D8]/30 inline-flex items-center justify-center hover:bg-[#F8F1D8]/10 transition-colors"
              >
                <Rss className="w-4 h-4" />
              </a>
              <button
                type="button"
                onClick={() => openBooking()}
                data-testid="footer-book-now"
                className="btn-shine inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm tracking-wider uppercase bg-[#F8F1D8] text-[#0A1838] hover:bg-[#EAD584] transition-colors"
              >
                Book Now
              </button>
            </div>
          </div>
        </div>

        <div className="pt-8 flex flex-wrap items-center justify-between gap-4 text-xs opacity-70 font-light">
          <div>© {new Date().getFullYear()} Beauty &amp; Balance by Bella. All rights reserved.</div>
          <div>Crafted for slow, intentional self-care.</div>
        </div>
      </div>
    </footer>
  );
}
